<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">CONTENTS</p>
<p class="toc"><a href="#/Acknowledgements">Acknowledgements</a></p>
<p class="toc"><a href="#/Introduction">Introduction</a></p>
<p class="toc"><a href="#/Glossary">Glossary of Southern Appalachian Food Terms</a></p>
<p class="toc1"><a href="#/Chapter1#C1">1. Makin’s from Corn and Cornmeal: The Soul of Appalachian Cooking</a></p>
<p class="toc"><span href="#/Chapter2#C2" title="Link target outside of Sample">2. Cathead Biscuits, Biscuit Bread and More Wonders from Wheat</span></p>
<p class="toc"><span href="#/Chapter3#C3" title="Link target outside of Sample">3. Fancy Doin’s: Other Breads and Baked Goods</span></p>
<p class="toc"><span href="#/Chapter4#C4" title="Link target outside of Sample">4. Pork: The Main Meat of Appalachia</span></p>
<p class="toc"><span href="#/Chapter5#C5" title="Link target outside of Sample">5. Preacher Bird</span></p>
<p class="toc"><span href="#/Chapter6#C6" title="Link target outside of Sample">6. Beef</span></p>
<p class="toc"><span href="#/Chapter7#C7" title="Link target outside of Sample">7. Meat from Nature’s Larder</span></p>
<p class="toc"><span href="#/Chapter8#C8" title="Link target outside of Sample">8. Fish</span></p>
<p class="toc"><span href="#/Chapter9#C9" title="Link target outside of Sample">9. You’ve Got to Have Gravy</span></p>
<p class="toc"><span href="#/Chapter10#C10" title="Link target outside of Sample">10. Spring Vegetables</span></p>
<p class="toc"><span href="#/Chapter11#C11" title="Link target outside of Sample">11. The Bounty of Summer</span></p>
<p class="toc"><span href="#/Chapter12#C12" title="Link target outside of Sample">12. The Matchless Tomato</span></p>
<p class="toc"><span href="#/Chapter13#C13" title="Link target outside of Sample">13. Root Crops</span></p>
<p class="toc"><span href="#/Chapter14#C14" title="Link target outside of Sample">14. Fall and Winter Vegetables</span></p>
<p class="toc"><span href="#/Chapter15#C15" title="Link target outside of Sample">15. Vegetables and Other Foods from the Wild</span></p>
<p class="toc"><span href="#/Chapter16#C16" title="Link target outside of Sample">16. Domestic Fruits</span></p>
<p class="toc"><span href="#/Chapter17#C17" title="Link target outside of Sample">17. Fruits from the Wild</span></p>
<p class="toc"><span href="#/Chapter18#C18" title="Link target outside of Sample">18. Melons</span></p>
<p class="toc"><span href="#/Chapter19#C19" title="Link target outside of Sample">19. Berries: Homegrown and from Nature</span></p>
<p class="toc"><span href="#/Chapter20#C20" title="Link target outside of Sample">20. Dried Foods</span></p>
<p class="toc"><span href="#/Chapter21#C21" title="Link target outside of Sample">21. Pickles</span></p>
<p class="toc"><span href="#/Chapter22#C22" title="Link target outside of Sample">22. Jellies, Jams and Fruit Butters</span></p>
<p class="toc"><span href="#/Chapter23#C23" title="Link target outside of Sample">23. Cakes</span></p>
<p class="toc"><span href="#/Chapter24#C24" title="Link target outside of Sample">24. Pies and Cobblers</span></p>
<p class="toc"><span href="#/Chapter25#C25" title="Link target outside of Sample">25. Cookies, Bars and Other Sweets</span></p>
<p class="toc"><span href="#/Chapter26#C26" title="Link target outside of Sample">26. Candy, Syrups and Special Treats</span></p>
<p class="toc"><span href="#/Chapter27#C27" title="Link target outside of Sample">27. To Quench One’s Thirst</span></p>
<p class="toc1"><span href="#/Author" title="Link target outside of Sample">About the Authors</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?59ff9d41